export const parseNumber = (n: number) => {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: n % 1 ? 1 : 0 }).format(n);
};

export const getRandomRange = (from: number, to: number, length = 10) => {
  const a = [from];
  for(let i = 0; i < length - 2; i++){
    a.push(from + a.length * 15);
  }
  a.push(to);
  return a;
};

export const getBb = (balance: number, bigBlind: number, isAnte?: boolean) => {
  const bb = Math.round(10 * balance / bigBlind) / 10;
  return !bb && isAnte ? 0.1 : bb;
};